import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles, Box, Typography } from '@material-ui/core'

const Footer = () => {
  const useStyles = makeStyles((theme) => ({
    PAT: {
      color: theme.palette.grey[700]
    }
  }))

  const classes = useStyles()

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={2}
      py={2}
      borderTop={0.5}
      borderColor="#aaa"
    >
      <Typography variant="body2" className={classes.PAT}>&copy; {new Date().getFullYear()}</Typography>
      <Typography className={classes.PAT} component={Link} to="/privacy and terms">
        Privacy & Terms
      </Typography>
    </Box>
  )
}

export default Footer
